"use client";

import { createContext, useContext, useTransition, type ReactNode } from "react";
import { Loader2 } from "lucide-react";

type CatalogNavContextValue = {
  startTransition: (fn: () => void) => void;
  isPending: boolean;
};

const CatalogNavContext = createContext<CatalogNavContextValue | null>(null);

export function CatalogNavProvider({ children }: { children: ReactNode }) {
  const [isPending, startTransition] = useTransition();
  return (
    <CatalogNavContext.Provider value={{ startTransition, isPending }}>
      {children}
    </CatalogNavContext.Provider>
  );
}

export function useCatalogNav() {
  const ctx = useContext(CatalogNavContext);
  if (!ctx) {
    throw new Error("useCatalogNav must be used within CatalogNavProvider");
  }
  return ctx;
}

/** Колонка с результатами: оверлей при смене фильтров (useTransition + router). */
export function CatalogResultsColumn({ children }: { children: ReactNode }) {
  const { isPending } = useCatalogNav();
  return (
    <div className="flex-1 relative min-h-[280px]">
      {isPending && (
        <div
          className="absolute inset-0 z-20 flex flex-col items-center justify-start pt-16 sm:pt-24 gap-3 rounded-2xl bg-white/75 backdrop-blur-[2px] pointer-events-none"
          aria-busy="true"
          aria-live="polite"
        >
          <Loader2 className="h-9 w-9 animate-spin text-[#E63946]" />
        </div>
      )}
      <div className={isPending ? "opacity-50 transition-opacity duration-200" : ""}>{children}</div>
    </div>
  );
}
